// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__Yx8zT","box":"WorkspacesBox_box__3Nn_J","node":"WorkspacesBox_node__127Dg"};